import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryAdmOrders = {
  async admOrders(_parent, args, context, _info) {
    const { admNumber, page, size, sort, filterValues } = args

    const hasFilter = filterValues && filterValues.length > 0
    const method = hasFilter ? "orders: findOrdersByAdmAndFilter" : "orders: findOrdersByAdm"

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    const graphiQLQueryObject = [
      {
        method,
        variables: {
          admNumber,
          ...(hasFilter && { filters: filterValues }),
          page,
          size,
          ...(sort && { sort: EinzaGraphiQLService.formatSortParam(sort) }),
        },
        fields: ["number", "numberOfElements", "totalElements", "totalPages"],
        expandedFields: {
          content: [
            "orderNumberLong: orderNumber",
            "orderNumberShort: orderNumber2",
            "customerNumber",
            "companyName1",
            "companyName2",
            "paymentMethod",
            "orderType",
            "orderDate",
            "admNumber",
            "totalAmount",
            "branchNumber",
            "customerBranchNumber",
            "orderStatus",
            "approvalDate",
            "customerOrderText",
            "picklist",
          ],
        },
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const admOrdersResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.orders

    if (!admOrdersResponse?.content || admOrdersResponse?.content?.length < 1)
      return {
        items: [],
        page: 0,
        size: 0,
        total: 0,
        totalPages: 0,
      }

    return {
      items: admOrdersResponse?.content,
      page,
      size,
      total: admOrdersResponse?.totalElements,
      totalPages: admOrdersResponse?.totalPages,
    }
  },
}
